export default __webpack_public_path__ + "static/media/Biogas.e99111cc.jpg";